// Schema URL should be uploaded to S3 at: s3://withjoy.com/assets/public/schemas/
export const EVENT_COUNTDOWN_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/eventCountdownSchemaV1_0_2.json';
export const EVENT_COUNTDOWN_COMPONENT_TYPE = 'EventCountdown' as const;
